import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { ArticuloProveedor } from 'app/models/articuloproveedor.models';

@Injectable({ providedIn: 'root' })
export class ArticuloProveedorService {
  constructor(private http: HttpClient) {}

  addProveedorArticulo(articleId: number, supplierId: number): Observable<ArticuloProveedor> {
    const data = { articleId, supplierId };
    return this.http.post<ArticuloProveedor>(`${environment.apiUrl}article-supplier`, data);
  }

  updateProveedorArticulo(id: number, data: any): Observable<ArticuloProveedor> {
    return this.http.patch<ArticuloProveedor>(`${environment.apiUrl}article-supplier/${id}`, data);
  }

  deleteProveedorArticulo(articleId: number, supplierId: number): Observable<void> {
    return this.http.delete<void>(`${environment.apiUrl}article-supplier/unlink/${articleId}/${supplierId}`);
  }

  getArticulosByProveedor(proveedorId: number) {
    return this.http.get<any[]>(`${environment.apiUrl}article-supplier/by-supplier/${proveedorId}`);
  }

  bulkLinkProveedorArticulos(supplierId: number, articleIds: number[]): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}article-supplier/bulk-link`, { supplierId, articleIds });
  }
}
